import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { DataGrid, IGridColDef, Grid, Button, Stack, Checkbox, IconButton } from 'src/components';
import Card from 'src/components/Card';
import CardContent from 'src/components/CardContent';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import { translate } from 'src/i18n/tHelper';
import VwKurumbonustanimdetayDTO from 'src/models/KurumBonusTanim/VwKurumbonustanimdetayDTO';
import IptalNedenSecim from 'src/parts/Genel/IptalNedenSecim';
import RecordInfo from 'src/parts/Genel/record.info';
import api from 'src/services/core/api';
import { useKurumBonusTanimDetayListesiQuery, useKurumBonusTanimDetaySilMutation } from 'src/services/KurumBonusTanimlari/KurumBonusTanimlariApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { kurumBonusTanimlariTestBazliSlice } from 'src/store/Slices/KurumBonusTanimlari/KurumBonusTanimlariTestBazliSlice';

const translatePath = "pages|kurumBonusTanimlari";
const KurumBonusTanimlariTestBazliListesi = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlariTestBazli);
    const kurumBonusTanimState = useAppSelector(s => s.kurumBonusTanimlari);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [iptal, setIptal] = useState<boolean>(false);

    const query = useKurumBonusTanimDetayListesiQuery({ kurumBonusTanimId: kurumBonusTanimState.activeRow?.id, iptalGosterme: state.iptalGosterme }, { skip: kurumBonusTanimState.activeRow?.id > 0 ? false : true, refetchOnMountOrArgChange: true });
    const [iptalEt, iptalEtState] = useKurumBonusTanimDetaySilMutation();

    const handlerEdit = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumbonustanimdetayDTO): void => {
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setActiveRow(row));
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setOpen(true));
    }
    const handlerDelete = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumbonustanimdetayDTO): void => {
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setActiveRow(row));
        setIptal(true);
    }
    const handlerTestVeVeriyeGore = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumbonustanimdetayDTO): void => {
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setActiveRow(row));
        navigate("test-ve-veriye-gore");
    }

    const columns: IGridColDef<VwKurumbonustanimdetayDTO>[] = [
        {
            field: "kurumAdi",
            headerName: translate(translatePath, "Kurum Adı"),
            flex: 1,
            minWidth: 250,
        },
        {
            field: "islemAdi",
            headerName: translate(translatePath, "İşlem Adı"),
            flex: 1,
            minWidth: 250,
        },
        {
            field: "oran",
            headerName: translate(translatePath, "Oran"),
            width: 100,
            type: "number",
            decimalScale: 2,
        },
        {
            field: "iptalTarihi",
            headerName: translate(translatePath, "İptal"),
            width: 75,
            type: "boolean",
            valueGetter: (params) => { return params.row?.iptalTarihi != null; }
        },
        {
            field: "action",
            headerName: translate(translatePath, "İşlemler"),
            width: 150,
            renderCell: (params) => {
                return (
                    <Stack direction="row">
                        {!params.row?.iptalTarihi && (
                            <>
                                <IconButton disabled={kurumBonusTanimState.activeRow?.bonusYontem !== 3} customType="test-data-based" toolTip="Teste ve Veriye Göre" onClick={(e) => { handlerTestVeVeriyeGore(e, params.row); }} />
                                <IconButton customType="edit" onClick={(e) => { handlerEdit(e, params.row); }} />
                                <IconButton customType="delete" loading={params.row?.id === iptalEtState.originalArgs?.id && iptalEtState.isLoading} onClick={(e) => { handlerDelete(e, params.row); }} />
                            </>
                        )}
                        <RecordInfo
                            id={params.row.id}
                            eklemeTarihi={params.row.eklemeTarih}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            guncellemeTarihi={params.row.guncellemeTarihi}
                            guncelleyenKullanici={params.row.guncelleyenKullanici}
                            iptalKullanici={params.row.iptalKullanici}
                            iptalTarihi={params.row.iptalTarihi}
                            iptalNedenGrupId={ParametreGrupEnum.TanimIptalNedenleri}
                            iptalNedenId={params.row.iptalNedenId}
                        />
                    </Stack>
                );
            },
        },
    ];

    const filterData = (data: Array<VwKurumbonustanimdetayDTO>): Array<VwKurumbonustanimdetayDTO> => {
        if (!Array.isArray(data)) return [];
        return data;
    };

    const handlerSearch = (event: React.MouseEvent<HTMLButtonElement>): void => {
        dispatch(api.util.invalidateTags(["KurumBonusTanimlariDetay"]));
    }
    const handlerAdd = (event: React.MouseEvent<HTMLButtonElement>): void => {
        if (kurumBonusTanimState.activeRow?.id <= 0) return;
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setActiveRow({ ...new VwKurumbonustanimdetayDTO(), fkBonustanimId: kurumBonusTanimState.activeRow?.id }));
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setOpen(true));
    }
    const handlerBack = (event: React.MouseEvent<HTMLButtonElement>): void => {
        navigate(-1);
    }

    return (
        <>
            <Card>
                <CardContent>
                    <DataGrid
                        sx={{ height: "70vh" }}
                        pinnedColumns={{ right: ["action"] }}
                        backButton={<Button customType="back" onClick={handlerBack} />}
                        searchButton={<Button customType="search" loading={query.isFetching} onClick={handlerSearch} />}
                        addButton={<Button customType="add" onClick={handlerAdd} />}
                        loading={query.isFetching}
                        rows={filterData(query.data)}
                        columns={columns}
                        addHeaderColumn={
                            <Stack direction="row">
                                <Checkbox
                                    label={translate(translatePath, "İptalleri Göster")}
                                    checked={state.iptalGosterme === "E"}
                                    onChange={(e, checked) => { dispatch(kurumBonusTanimlariTestBazliSlice.actions.setIptalGosterme(checked ? "E" : "H")); }}
                                />
                            </Stack>
                        }
                    />
                </CardContent>
            </Card>
            <IptalNedenSecim
                title={translate(translatePath, "Kurum Bonus Tanımı Test Bazlı İptal")}
                parameterType={ParametreGrupEnum.TanimIptalNedenleri}
                loading={iptalEtState.isLoading}
                open={iptal}
                onClosed={() => { setIptal(false); }}
                onSelected={async (iptalNedenId, aciklama, iptalValue) => {
                    if (!iptalEtState.isLoading)
                        await iptalEt({ ...state.activeRow, iptalNedenId: iptalNedenId, iptalAciklama: aciklama }).unwrap().then(() => { }).catch(e => e);
                }}
            />
        </>
    );
};

export default KurumBonusTanimlariTestBazliListesi;